import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.12656 15L12.0066 11.12L15.8866 15C16.2766 15.39 16.9066 15.39 17.2966 15C17.6866 14.61 17.6866 13.98 17.2966 13.59L12.7066 9.00001C12.5197 8.81275 12.2661 8.70752 12.0016 8.70752C11.737 8.70752 11.4834 8.81275 11.2966 9.00001L6.70656 13.59C6.31656 13.98 6.31656 14.61 6.70656 15C7.09656 15.38 7.73656 15.39 8.12656 15Z",
		fill: "currentColor"
	})
});
export default SvgArrowUp;
